// Taşeron portalı — İş İzni enum yardımcıları (durum filtresi seçenekleri; renkler `status/tone.ts`).
// Wire değerleri api-contract §14/§21'den; çeviri (etiket) çağıran ekrandadır (i18n key =
// `permits.status.<value>`; tehlike sınıfı `HazardTag` + `hazard.<n>`). İzin tipi (eski `workType`)
// artık firma-tanımlı `PermitType`'tır (§22); supplier salt-okur → tip adı DTO'dan (`permitTypeName`).
// (web-expert permitEnums deseniyle aynı — supplier tarafı salt-okur olduğundan
// `isPermitEditable`/yaşam döngüsü yardımcıları YOKTUR.)

import type { PermitStatus } from '@isgportal/shared';

/** Durum filtresi seçenekleri (12 değer, türetilmiş `Expired` dahil; §14/§21). Legacy `Approved`
 * seçeneği BACKLOG'da (S37 plan Status) — satırları artık `AwaitingSupplierInfo` olarak sunulur. */
export const PERMIT_STATUSES: PermitStatus[] = [
  'Draft',
  'Submitted',
  'Approved',
  'AwaitingSupplierInfo',
  'AwaitingAiReview',
  'Revision',
  'DepartmentReview',
  'AwaitingEntryPermit',
  'Active',
  'Rejected',
  'Expired',
  'Closed',
];
